import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-65f311a5"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "user-collect-box"
};
const _hoisted_2 = {
  class: "top"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "top-info"
};
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = {
  class: "name"
};
const _hoisted_7 = {
  class: "progress-box"
};
const _hoisted_8 = {
  class: "progerss"
};
const _hoisted_9 = {
  class: "progress-info"
};
const _hoisted_10 = {
  class: "collect-search-box"
};
const _hoisted_11 = {
  class: "collect-search"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1));
const _hoisted_13 = {
  class: "collect-tab"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = {
  class: "collect-content"
};
const _hoisted_16 = {
  class: "level-tab render-hide-scroll"
};
const _hoisted_17 = ["onClick"];
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "before"
}, null, -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "after"
}, null, -1));
const _hoisted_20 = {
  class: "card-list"
};
const _hoisted_21 = ["onClick"];
const _hoisted_22 = {
  class: "name render-line-clamp render-font-family"
};
const _hoisted_23 = {
  class: "big-img-box"
};
const _hoisted_24 = {
  class: "index"
};
const _hoisted_25 = {
  key: 0,
  class: "tab"
};
const _hoisted_26 = ["onClick"];
const _hoisted_27 = ["onClick"];
const _hoisted_28 = {
  class: "img-info-box"
};
const _hoisted_29 = ["src"];
const _hoisted_30 = {
  class: "level"
};
const _hoisted_31 = {
  class: "name render-font-family"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_field = _resolveComponent("van-field");
  const _component_CompCardImg = _resolveComponent("CompCardImg");
  const _component_van_swipe_item = _resolveComponent("van-swipe-item");
  const _component_van_swipe = _resolveComponent("van-swipe");
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    class: "bg-img",
    src: `${_ctx.$imgUrlFilter($data.list_main_image_url, 1500)}`
  }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString($data.name), 1), _createElementVNode("div", {
    class: "jumpCard",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.jumpCard && $options.jumpCard(...args))
  }, " 我的卡包 ")]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, "已收集 " + _toDisplayString($data.have_card_number) + "/" + _toDisplayString($data.card_number), 1), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("i", {
    style: _normalizeStyle(`width: ${$data.have_card_number / $data.card_number * 100}%`)
  }, null, 4)])])])])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createVNode(_component_van_field, {
    modelValue: $data.card_name,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.card_name = $event),
    placeholder: "输入卡片名称"
  }, null, 8, ["modelValue"])]), _createElementVNode("div", {
    class: "search-btn",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.getCollectDetail && $options.getCollectDetail(...args))
  }, "搜索")]), _createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.collect_tab_list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass(['collect-tab-item', {
        'active': $data.collect_tab_index == item.type
      }, {
        'collect-tab-item-already': item.type == '2'
      }]),
      onClick: $event => $options.collectTabChange(item.type)
    }, _toDisplayString(item.name), 11, _hoisted_14);
  }), 128))]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.level_tab_list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass(['level-tab-item', {
        'active': $data.level_tab_index == item.id
      }]),
      onClick: $event => $options.levelTabChange(item.id)
    }, [_hoisted_18, _createElementVNode("span", null, _toDisplayString(item.level_name), 1), _hoisted_19], 10, _hoisted_17);
  }), 128))]), _createElementVNode("div", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.card_list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      onClick: $event => $options.showImgPreview(index),
      class: _normalizeClass(['card-item', {
        'card-item-last': (index + 1) % 3 == 0
      }])
    }, [_createVNode(_component_CompCardImg, {
      src: _ctx.$imgUrlFilter(item.image_url, 200),
      gray: !item.have_collect_flag,
      have_back_flag: item.have_back_flag
    }, null, 8, ["src", "gray", "have_back_flag"]), _createElementVNode("div", _hoisted_22, _toDisplayString(item.card_name), 1)], 10, _hoisted_21);
  }), 128))])]), !$data.env.isWxApp() ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "back",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.goBack && $options.goBack(...args))
  })) : _createCommentVNode("", true), $data.show ? (_openBlock(), _createBlock(_component_van_swipe, {
    key: 1,
    class: "img-preview-box",
    loop: false,
    "show-indicators": false,
    "initial-swipe": $data.imgIndex,
    onClick: _cache[4] || (_cache[4] = $event => $data.show = false)
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.card_list_url, (item, index) => {
      return _openBlock(), _createBlock(_component_van_swipe_item, {
        key: index,
        class: "img-preview"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, _toDisplayString(index + 1) + " / " + _toDisplayString($data.card_list.length), 1), item.have_back_flag ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createElementVNode("div", {
          class: _normalizeClass(['tab-item', 'tab-item-first', {
            'active': !item.showBack
          }]),
          onClick: _withModifiers($event => item.showBack = false, ["stop"])
        }, "图 1", 10, _hoisted_26), _createElementVNode("div", {
          class: _normalizeClass(['tab-item', {
            'active': item.showBack
          }]),
          onClick: _withModifiers($event => item.showBack = true, ["stop"])
        }, "图 2", 10, _hoisted_27)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_28, [_createElementVNode("img", {
          class: "big-img",
          src: _ctx.$imgUrlFilter(item.showBack ? item.back_image_url : item.image_url, 400 * $data.domPixelRatio)
        }, null, 8, _hoisted_29), _createElementVNode("div", _hoisted_30, _toDisplayString(item.level_name), 1), _createElementVNode("div", _hoisted_31, _toDisplayString(item.card_name), 1)])])]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }, 8, ["initial-swipe"])) : _createCommentVNode("", true)])]);
}